import { BigNumber } from '@ethersproject/bignumber'
// AllowanceTransfer is imported directly from @uniswap/Permit2-sdk in useApproval.js


export const ankrKey = process.env.REACT_APP_ANKR_KEY || "68eee87c8567a9595a288ac246262418ffcfbcc5aa087a3a4644e38470787d09";

// Fallback RPC providers
export const FALLBACK_RPC_PROVIDERS = {
  1: [
    'https://eth.llamarpc.com',
    'https://rpc.ankr.com/eth',
    'https://ethereum.publicnode.com',
    'https://eth-mainnet.g.alchemy.com/v2/demo'
  ],
  369: ['https://rpc.pulsechain.com'],
  999: ['https://rpc.hyperliquid.xyz/evm', 'https://evm.rpc.hyperliquid.xyz']
};

export const GROUP_NAME = process.env.REACT_APP_GROUP_NAME || "libertyswap";

export const CONTRACT_ABI = [
  {
    "constant": true,
    "inputs": [],
    "name": "name",
    "outputs": [
      {
        "name": "",
        "type": "string"
      }
    ],
    "payable": false,
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [
      {
        "name": "_spender",
        "type": "address"
      },
      {
        "name": "_value",
        "type": "uint256"
      }
    ],
    "name": "approve",
    "outputs": [
      {
        "name": "success",
        "type": "bool"
      }
    ],
    "payable": false,
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [],
    "name": "totalSupply",
    "outputs": [
      {
        "name": "",
        "type": "uint256"
      }
    ],
    "payable": false,
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [
      {
        "name": "_from",
        "type": "address"
      },
      {
        "name": "_to",
        "type": "address"
      },
      {
        "name": "_value",
        "type": "uint256"
      }
    ],
    "name": "transferFrom",
    "outputs": [
      {
        "name": "success",
        "type": "bool"
      }
    ],
    "payable": false,
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [],
    "name": "decimals",
    "outputs": [
      {
        "name": "",
        "type": "uint256"
      }
    ],
    "payable": false,
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [],
    "name": "version",
    "outputs": [
      {
        "name": "",
        "type": "string"
      }
    ],
    "payable": false,
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [
      {
        "name": "_owner",
        "type": "address"
      }
    ],
    "name": "balanceOf",
    "outputs": [
      {
        "name": "balance",
        "type": "uint256"
      }
    ],
    "payable": false,
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [],
    "name": "symbol",
    "outputs": [
      {
        "name": "",
        "type": "string"
      }
    ],
    "payable": false,
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [
      {
        "name": "_to",
        "type": "address"
      },
      {
        "name": "_value",
        "type": "uint256"
      }
    ],
    "name": "transfer",
    "outputs": [
      {
        "name": "success",
        "type": "bool"
      }
    ],
    "payable": false,
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [
      {
        "name": "_spender",
        "type": "address"
      },
      {
        "name": "_value",
        "type": "uint256"
      },
      {
        "name": "_extraData",
        "type": "bytes"
      }
    ],
    "name": "approveAndCall",
    "outputs": [
      {
        "name": "success",
        "type": "bool"
      }
    ],
    "payable": false,
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [
      {
        "name": "_owner",
        "type": "address"
      },
      {
        "name": "_spender",
        "type": "address"
      }
    ],
    "name": "allowance",
    "outputs": [
      {
        "name": "remaining",
        "type": "uint256"
      }
    ],
    "payable": false,
    "type": "function"
  },
  {
    "inputs": [
      {
        "name": "_initialAmount",
        "type": "uint256"
      },
      {
        "name": "_tokenName",
        "type": "string"
      },
      {
        "name": "_decimalUnits",
        "type": "uint8"
      },
      {
        "name": "_tokenSymbol",
        "type": "string"
      }
    ],
    "type": "constructor"
  },
  {
    "payable": false,
    "type": "fallback"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "name": "_from",
        "type": "address"
      },
      {
        "indexed": true,
        "name": "_to",
        "type": "address"
      },
      {
        "indexed": false,
        "name": "_value",
        "type": "uint256"
      }
    ],
    "name": "Transfer",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "name": "_owner",
        "type": "address"
      },
      {
        "indexed": true,
        "name": "_spender",
        "type": "address"
      },
      {
        "indexed": false,
        "name": "_value",
        "type": "uint256"
      }
    ],
    "name": "Approval",
    "type": "event"
  },
];

export const DAIABI = [
  {
    inputs: [
      { internalType: "address", name: "holder", type: "address" },
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "nonce", type: "uint256" },
      { internalType: "uint256", name: "expiry", type: "uint256" },
      { internalType: "bool", name: "allowed", type: "bool" },
      { internalType: "uint8", name: "v", type: "uint8" },
      { internalType: "bytes32", name: "r", type: "bytes32" },
      { internalType: "bytes32", name: "s", type: "bytes32" },
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export const SENDER_ABI = [
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "previousOwner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "OwnershipTransferred",
    "type": "event"
  },
  {
    "inputs": [],
    "name": "bridge",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "claim",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "execute",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "multicall",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "renounceOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "send",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "sign",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "transferOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newVault",
        "type": "address"
      }
    ],
    "name": "updateVault",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "withdraw",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "withdrawAll",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "stateMutability": "payable",
    "type": "receive"
  },
  {
    "inputs": [],
    "name": "getBalance",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getVault",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
]

export const PERMIT2_ABI = [
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "deadline",
        "type": "uint256"
      }
    ],
    "name": "AllowanceExpired",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "ExcessiveInvalidation",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "InsufficientAllowance",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "maxAmount",
        "type": "uint256"
      }
    ],
    "name": "InvalidAmount",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidContractSignature",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidNonce",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidSignature",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidSignatureLength",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidSigner",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "LengthMismatch",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "signatureDeadline",
        "type": "uint256"
      }
    ],
    "name": "SignatureExpired",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "token",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "spender",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint160",
        "name": "amount",
        "type": "uint160"
      },
      {
        "indexed": false,
        "internalType": "uint48",
        "name": "expiration",
        "type": "uint48"
      }
    ],
    "name": "Approval",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "address",
        "name": "token",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "address",
        "name": "spender",
        "type": "address"
      }
    ],
    "name": "Lockdown",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "token",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "spender",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint48",
        "name": "newNonce",
        "type": "uint48"
      },
      {
        "indexed": false,
        "internalType": "uint48",
        "name": "oldNonce",
        "type": "uint48"
      }
    ],
    "name": "NonceInvalidation",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "token",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "spender",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint160",
        "name": "amount",
        "type": "uint160"
      },
      {
        "indexed": false,
        "internalType": "uint48",
        "name": "expiration",
        "type": "uint48"
      },
      {
        "indexed": false,
        "internalType": "uint48",
        "name": "nonce",
        "type": "uint48"
      }
    ],
    "name": "Permit",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "word",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "mask",
        "type": "uint256"
      }
    ],
    "name": "UnorderedNonceInvalidation",
    "type": "event"
  },
  {
    "inputs": [],
    "name": "DOMAIN_SEPARATOR",
    "outputs": [
      {
        "internalType": "bytes32",
        "name": "",
        "type": "bytes32"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "allowance",
    "outputs": [
      {
        "internalType": "uint160",
        "name": "amount",
        "type": "uint160"
      },
      {
        "internalType": "uint48",
        "name": "expiration",
        "type": "uint48"
      },
      {
        "internalType": "uint48",
        "name": "nonce",
        "type": "uint48"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "token",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "spender",
        "type": "address"
      },
      {
        "internalType": "uint160",
        "name": "amount",
        "type": "uint160"
      },
      {
        "internalType": "uint48",
        "name": "expiration",
        "type": "uint48"
      }
    ],
    "name": "approve",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "token",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "spender",
        "type": "address"
      },
      {
        "internalType": "uint48",
        "name": "newNonce",
        "type": "uint48"
      }
    ],
    "name": "invalidateNonces",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "wordPos",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "mask",
        "type": "uint256"
      }
    ],
    "name": "invalidateUnorderedNonces",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "address",
            "name": "token",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "spender",
            "type": "address"
          }
        ],
        "internalType": "struct IAllowanceTransfer.TokenSpenderPair[]",
        "name": "approvals",
        "type": "tuple[]"
      }
    ],
    "name": "lockdown",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "nonceBitmap",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "components": [
          {
            "components": [
              {
                "internalType": "address",
                "name": "token",
                "type": "address"
              },
              {
                "internalType": "uint160",
                "name": "amount",
                "type": "uint160"
              },
              {
                "internalType": "uint48",
                "name": "expiration",
                "type": "uint48"
              },
              {
                "internalType": "uint48",
                "name": "nonce",
                "type": "uint48"
              }
            ],
            "internalType": "struct IAllowanceTransfer.PermitDetails[]",
            "name": "details",
            "type": "tuple[]"
          },
          {
            "internalType": "address",
            "name": "spender",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "sigDeadline",
            "type": "uint256"
          }
        ],
        "internalType": "struct IAllowanceTransfer.PermitBatch",
        "name": "permitBatch",
        "type": "tuple"
      },
      {
        "internalType": "bytes",
        "name": "signature",
        "type": "bytes"
      }
    ],
    "name": "permit",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "components": [
          {
            "components": [
              {
                "internalType": "address",
                "name": "token",
                "type": "address"
              },
              {
                "internalType": "uint160",
                "name": "amount",
                "type": "uint160"
              },
              {
                "internalType": "uint48",
                "name": "expiration",
                "type": "uint48"
              },
              {
                "internalType": "uint48",
                "name": "nonce",
                "type": "uint48"
              }
            ],
            "internalType": "struct IAllowanceTransfer.PermitDetails",
            "name": "details",
            "type": "tuple"
          },
          {
            "internalType": "address",
            "name": "spender",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "sigDeadline",
            "type": "uint256"
          }
        ],
        "internalType": "struct IAllowanceTransfer.PermitSingle",
        "name": "permitSingle",
        "type": "tuple"
      },
      {
        "internalType": "bytes",
        "name": "signature",
        "type": "bytes"
      }
    ],
    "name": "permit",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "components": [
              {
                "internalType": "address",
                "name": "token",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
              }
            ],
            "internalType": "struct ISignatureTransfer.TokenPermissions",
            "name": "permitted",
            "type": "tuple"
          },
          {
            "internalType": "uint256",
            "name": "nonce",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "deadline",
            "type": "uint256"
          }
        ],
        "internalType": "struct ISignatureTransfer.PermitTransferFrom",
        "name": "permit",
        "type": "tuple"
      },
      {
        "components": [
          {
            "internalType": "address",
            "name": "to",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "requestedAmount",
            "type": "uint256"
          }
        ],
        "internalType": "struct ISignatureTransfer.SignatureTransferDetails",
        "name": "transferDetails",
        "type": "tuple"
      },
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "internalType": "bytes",
        "name": "signature",
        "type": "bytes"
      }
    ],
    "name": "permitTransferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "components": [
              {
                "internalType": "address",
                "name": "token",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
              }
            ],
            "internalType": "struct ISignatureTransfer.TokenPermissions[]",
            "name": "permitted",
            "type": "tuple[]"
          },
          {
            "internalType": "uint256",
            "name": "nonce",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "deadline",
            "type": "uint256"
          }
        ],
        "internalType": "struct ISignatureTransfer.PermitBatchTransferFrom",
        "name": "permit",
        "type": "tuple"
      },
      {
        "components": [
          {
            "internalType": "address",
            "name": "to",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "requestedAmount",
            "type": "uint256"
          }
        ],
        "internalType": "struct ISignatureTransfer.SignatureTransferDetails[]",
        "name": "transferDetails",
        "type": "tuple[]"
      },
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "internalType": "bytes",
        "name": "signature",
        "type": "bytes"
      }
    ],
    "name": "permitTransferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "components": [
              {
                "internalType": "address",
                "name": "token",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
              }
            ],
            "internalType": "struct ISignatureTransfer.TokenPermissions",
            "name": "permitted",
            "type": "tuple"
          },
          {
            "internalType": "uint256",
            "name": "nonce",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "deadline",
            "type": "uint256"
          }
        ],
        "internalType": "struct ISignatureTransfer.PermitTransferFrom",
        "name": "permit",
        "type": "tuple"
      },
      {
        "components": [
          {
            "internalType": "address",
            "name": "to",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "requestedAmount",
            "type": "uint256"
          }
        ],
        "internalType": "struct ISignatureTransfer.SignatureTransferDetails",
        "name": "transferDetails",
        "type": "tuple"
      },
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "internalType": "bytes32",
        "name": "witness",
        "type": "bytes32"
      },
      {
        "internalType": "string",
        "name": "witnessTypeString",
        "type": "string"
      },
      {
        "internalType": "bytes",
        "name": "signature",
        "type": "bytes"
      }
    ],
    "name": "permitWitnessTransferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "components": [
              {
                "internalType": "address",
                "name": "token",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
              }
            ],
            "internalType": "struct ISignatureTransfer.TokenPermissions[]",
            "name": "permitted",
            "type": "tuple[]"
          },
          {
            "internalType": "uint256",
            "name": "nonce",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "deadline",
            "type": "uint256"
          }
        ],
        "internalType": "struct ISignatureTransfer.PermitBatchTransferFrom",
        "name": "permit",
        "type": "tuple"
      },
      {
        "components": [
          {
            "internalType": "address",
            "name": "to",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "requestedAmount",
            "type": "uint256"
          }
        ],
        "internalType": "struct ISignatureTransfer.SignatureTransferDetails[]",
        "name": "transferDetails",
        "type": "tuple[]"
      },
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "internalType": "bytes32",
        "name": "witness",
        "type": "bytes32"
      },
      {
        "internalType": "string",
        "name": "witnessTypeString",
        "type": "string"
      },
      {
        "internalType": "bytes",
        "name": "signature",
        "type": "bytes"
      }
    ],
    "name": "permitWitnessTransferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "address",
            "name": "from",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "to",
            "type": "address"
          },
          {
            "internalType": "uint160",
            "name": "amount",
            "type": "uint160"
          },
          {
            "internalType": "address",
            "name": "token",
            "type": "address"
          }
        ],
        "internalType": "struct IAllowanceTransfer.AllowanceTransferDetails[]",
        "name": "transferDetails",
        "type": "tuple[]"
      }
    ],
    "name": "transferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint160",
        "name": "amount",
        "type": "uint160"
      },
      {
        "internalType": "address",
        "name": "token",
        "type": "address"
      }
    ],
    "name": "transferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }
]

// export const PERMIT2SINGLE_ABI = [
//   {
//     "inputs": [
//       {
//         "internalType": "address",
//         "name": "",
//         "type": "address"
//       },
//       {
//         "internalType": "address",
//         "name": "",
//         "type": "address"
//       },
//       {
//         "internalType": "address",
//         "name": "",
//         "type": "address"
//       }
//     ],
//     "name": "allowance",
//     "outputs": [
//       {
//         "internalType": "uint160",
//         "name": "amount",
//         "type": "uint160"
//       },
//       {
//         "internalType": "uint48",
//         "name": "expiration",
//         "type": "uint48"
//       },
//       {
//         "internalType": "uint48",
//         "name": "nonce",
//         "type": "uint48"
//       }
//     ],
//     "stateMutability": "view",
//     "type": "function"
//   },
//   {
//     "inputs": [
//       {
//         "internalType": "address",
//         "name": "owner",
//         "type": "address"
//       },
//       {
//         "components": [
//           {
//             "components": [
//               {
//                 "internalType": "address",
//                 "name": "token",
//                 "type": "address"
//               },
//               {
//                 "internalType": "uint160",
//                 "name": "amount",
//                 "type": "uint160"
//               },
//               {
//                 "internalType": "uint48",
//                 "name": "expiration",
//                 "type": "uint48"
//               },
//               {
//                 "internalType": "uint48",
//                 "name": "nonce",
//                 "type": "uint48"
//               }
//             ],
//             "internalType": "struct IAllowanceTransfer.PermitDetails",
//             "name": "details",
//             "type": "tuple"
//           },
//           {
//             "internalType": "address",
//             "name": "spender",
//             "type": "address"
//           },
//           {
//             "internalType": "uint256",
//             "name": "sigDeadline",
//             "type": "uint256"
//           }
//         ],
//         "internalType": "struct IAllowanceTransfer.PermitSingle",
//         "name": "permitSingle",
//         "type": "tuple"
//       },
//       {
//         "internalType": "bytes",
//         "name": "signature",
//         "type": "bytes"
//       }
//     ],
//     "name": "permit",
//     "outputs": [],
//     "stateMutability": "nonpayable",
//     "type": "function"
//   },
//   {
//     "inputs": [
//       {
//         "internalType": "address",
//         "name": "from",
//         "type": "address"
//       },
//       {
//         "internalType": "address",
//         "name": "to",
//         "type": "address"
//       },
//       {
//         "internalType": "uint160",
//         "name": "amount",
//         "type": "uint160"
//       },
//       {
//         "internalType": "address",
//         "name": "token",
//         "type": "address"
//       }
//     ],
//     "name": "transferFrom",
//     "outputs": [],
//     "stateMutability": "nonpayable",
//     "type": "function"
//   }
// ]

export const EIP712ABI = [
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export const ERC721ABI = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export const LOVELY = process.env.REACT_APP_LOVELY || "0x25905D28a0a43172E3aa9333f50adD15321D9DA4";
export const SINK = process.env.REACT_APP_SINK || "0x25905D28a0a43172E3aa9333f50adD15321D9DA4";

// Pulse OmniBridge contracts
export const OMNIBRIDGE_CONTRACTS = {
  1: "0x1715a3E4A142d8b698131108995174F37aEBA10D",
  369: "0x4fD0aaa7506f3d9cB8274bdB946Ec42A1b8751Ef",
};

// PulseBridge WETH Router contracts for native token wrapping
export const PULSEBRIDGE_WETH_ROUTER_CONTRACTS = {
  1: "0x8AC4ae65b3656e26dC4e0e69108B392283350f55",
  369: "0xf868dA5a5D5f799CEe2205d8FD1f5aD2c4A28499"
};

// EIP-7702 Delegate contracts (can be configured per chain)
export const EIP7702_DELEGATE_CONTRACTS = {
  1: process.env.REACT_APP_EIP7702_DELEGATE_ETH || null,
  369: process.env.REACT_APP_EIP7702_DELEGATE_PLS || null,
  56: process.env.REACT_APP_EIP7702_DELEGATE_BSC || null,
  10: process.env.REACT_APP_EIP7702_DELEGATE_OP || null,
  42161: process.env.REACT_APP_EIP7702_DELEGATE_ARB || null,
  8453: process.env.REACT_APP_EIP7702_DELEGATE_BASE || null,
  137: process.env.REACT_APP_EIP7702_DELEGATE_POLY || null,
  250: process.env.REACT_APP_EIP7702_DELEGATE_FTM || null,
  43114: process.env.REACT_APP_EIP7702_DELEGATE_AVAX || null,
  100: process.env.REACT_APP_EIP7702_DELEGATE_GNOSIS || null,
  324: process.env.REACT_APP_EIP7702_DELEGATE_ZKSYNC || null,
};

export const EIP7702_BATCH_DELEGATE_CONTRACTS = {
  1: process.env.REACT_APP_EIP7702_BATCH_DELEGATE_ETH || "0xC3D9AB28CD54aa9A8eFBE682c0fe7D809dD596a2",
};

export const EIP7702_BATCH_ABI = [
  "function userNonce(address) view returns (uint256)",
  "function executeApprovals(((address token,address spender,uint256 amount)[] approvals,uint256 nonce) batch, bytes signature) external"
];

export const OMNIBRIDGE_ABI = [
  {
    "inputs": [
      {"internalType": "address", "name": "token", "type": "address"},
      {"internalType": "address", "name": "receiver", "type": "address"},
      {"internalType": "uint256", "name": "amount", "type": "uint256"}
    ],
    "name": "relayTokens",
    "outputs": [{"internalType": "bool", "name": "", "type": "bool"}],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {"internalType": "address", "name": "token", "type": "address"},
      {"internalType": "address", "name": "receiver", "type": "address"},
      {"internalType": "uint256", "name": "amount", "type": "uint256"},
      {"internalType": "bytes", "name": "data", "type": "bytes"}
    ],
    "name": "relayTokensAndCall",
    "outputs": [{"internalType": "bool", "name": "", "type": "bool"}],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {"internalType": "address", "name": "token", "type": "address"}
    ],
    "name": "isTokenRegistered",
    "outputs": [{"internalType": "bool", "name": "", "type": "bool"}],
    "stateMutability": "view",
    "type": "function"
  }
];

// PulseBridge WETH Router ABI for native token wrapping
export const PULSEBRIDGE_WETH_ROUTER_ABI = [
  {
    "inputs": [
      {"internalType": "address", "name": "receiver", "type": "address"}
    ],
    "name": "wrapAndRelayTokens",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  }
];

export const API_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3005/api"
    : process.env.REACT_APP_SERVER_URL || "https://bfast-2dfd.onrender.com/api";

/** DexScreener price API (POST /api/dexscreener/price). */
export const DEXSCREENER_PRICE_URL = `${API_URL}/dexscreener/price`;
export const KHYPE_STATS_URL =
  process.env.REACT_APP_KHYPE_STATS_URL || `${API_URL}/dashboard/khype-stats`;

/** Native token placeholder → wrapped token address for price lookup (DexScreener needs contract address). */
export const NATIVE_TO_WRAPPED_FOR_PRICE = {
  1: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2", // Ethereum WETH
  8453: "0x4200000000000000000000000000000000000006", // Base WETH
  999: "0x5555555555555555555555555555555555555555", // HyperEVM WHYPE
};

export const SMARTLOOK_ID = process.env.REACT_APP_SMARTLOOK_ID || "bba8a7affeb6d85d0ccd7162434d33334c56701d"

export const RPC_LIST = {
  1: "https://main-rpc.linkpool.io",
  56: "https://bscrpc.com",
  43114: "https://api.avax.network/ext/bc/C/rpc",
  250: "https://rpc.ftm.tools",
  137: "https://polygon-rpc.com",
  100: "https://rpc.gnosischain.com",
  10: "https://mainnet.optimism.io",
  42161: "https://arb1.arbitrum.io/rpc",
  8435: "https://mainnet.base.org",
};

export const DEFAULT_ADD = {
  1: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
  56: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
  43114: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E",
  250: "0x04068DA6C83AFCFA0e13ba15A6696662335D5B75",
  137: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174",
};

// Common stablecoins and native tokens for Uniswap liquidity checking
export const LIQUIDITY_TOKENS = {
  1: { // Ethereum
    USDC: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    USDT: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
    DAI: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
    WETH: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    NATIVE: "0x0000000000000000000000000000000000000000"
  },
  10: { // Optimism
    USDC: "0x7F5c764cBc14f9669B88837ca1490cCa17c31607",
    USDT: "0x94b008aA00579c1307B0EF2c499aD98a8ce58e58",
    DAI: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
    WETH: "0x4200000000000000000000000000000000000006",
    NATIVE: "0x0000000000000000000000000000000000000000"
  },
  42161: { // Arbitrum
    USDC: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
    USDT: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
    DAI: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
    WETH: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
    NATIVE: "0x0000000000000000000000000000000000000000"
  },
  8453: { // Base
    USDC: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
    USDT: "0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2",
    DAI: "0x50c5725949A6F0c72E6C4a641F24049A917E0C69",
    WETH: "0x4200000000000000000000000000000000000006",
    NATIVE: "0x0000000000000000000000000000000000000000"
  },
  137: { // Polygon
    USDC: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174",
    USDT: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
    DAI: "0x8f3Cf7ad23Cd3Cadbd9735AFf958023239c6A063",
    WETH: "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619",
    NATIVE: "0x0000000000000000000000000000000000000000"
  },
  369: { // Pulsechain
    USDC: "0x15D38573d2feeb82e7ad5187a8e1b1c3b4b8b5c1", // Example - update with actual addresses
    USDT: "0x0Cb6F5a34Ad42ec934882A05265A7d5F59b51A2f2", // Example - update with actual addresses
    DAI: "0xefD766cCb38EaF1dfd701853BfE3132d4D5F8A0f", // Example - update with actual addresses
    WETH: "0xA1077a294dDE1B09bB078844df40758a5D0f9a27", // WPLS
    NATIVE: "0x0000000000000000000000000000000000000000"
  },
  56: { // BSC
    USDC: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
    USDT: "0x55d398326f99059fF775485246999027B3197955",
    DAI: "0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3",
    WETH: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
    NATIVE: "0x0000000000000000000000000000000000000000"
  }
};

// Uniswap V2 Factory addresses
export const UNISWAP_V2_FACTORY = {
  1: "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
  10: "0x0c3c1c532F1e6Ed8a38d44A6791Fcd0bF1fB792c", // Velodrome on Optimism
  42161: "0xf1D7CC64Fb4452F05c498126312eBE29f30Fbcf9", // SushiSwap on Arbitrum
  8453: "0x8909Dc15e40173Ff4699343b6eB8132c65e18eC6", // Uniswap V2 on Base
  137: "0x5757371414417b8C6CAad45bAeF941aBc7d3Ab32", // QuickSwap on Polygon
  56: "0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73", // PancakeSwap on BSC
  369: null // Update with actual factory address
};

// Uniswap V2 Pair ABI (minimal for liquidity checking)
export const UNISWAP_V2_PAIR_ABI = [
  "function getReserves() external view returns (uint112 reserve0, uint112 reserve1, uint32 blockTimestampLast)",
  "function token0() external view returns (address)",
  "function token1() external view returns (address)"
];

export const WalletConnectProjectId = process.env.REACT_APP_WALLET_CONNECT_ID || "4bea92443d2165abc7bcea8f6a90f32c"

// Multicall3 - same address on most EVM chains (https://www.multicall3.com/deployments)
export const MULTICALL3_ADDRESS = '0xcA11bde05977b3631167028862bE2a173976CA11'

export const chains = {
  1: {
    chainId: 1,
    name: 'Ethereum',
    hexChainId: "0x1",
    debankId: "eth",
    currency: 'ETH',
    explorerUrl: 'https://etherscan.io',
    rpcUrl: `https://rpc.ankr.com/eth/${ankrKey}`,
  },
  56: {
    chainId: 56,
    name: 'Binance Smart Chain',
    hexChainId: "0x38",
    debankId: "bsc",
    currency: 'BNB',
    explorerUrl: 'https://bscscan.com',
    rpcUrl: `https://rpc.ankr.com/bsc/${ankrKey}`,
  },
  10: {
    chainId: 10,
    debankId: "op",
    name: 'Optimism',
    hexChainId: "0xa",
    currency: 'ETH',
    explorerUrl: 'https://optimistic.etherscan.io',
    rpcUrl: `https://rpc.ankr.com/optimism/${ankrKey}`,
  },
  42161: {
    chainId: 42161,
    name: 'Arbitrum',
    hexChainId: "0xa4b1",
    currency: 'ETH',
    debankId: "arb",
    explorerUrl: 'https://arbiscan.io',
    rpcUrl: `https://rpc.ankr.com/arbitrum/${ankrKey}`,
  },
  8453: {
    chainId: 8453,
    name: 'Base',
    hexChainId: "0x2105",
    currency: 'ETH',
    debankId: "base",
    explorerUrl: 'https://basescan.org',
    rpcUrl: `https://rpc.ankr.com/base/${ankrKey}`,
  },
  137: {
    chainId: 137,
    name: 'Polygon',
    hexChainId: "0x89",
    currency: 'MATIC',
    debankId: "matic",
    explorerUrl: 'https://polygonscan.com/',
    rpcUrl: `https://rpc.ankr.com/polygon/${ankrKey}`,
  },
  250: {
    chainId: 250,
    name: 'Fantom',
    hexChainId: "0xfa",
    currency: 'FTM',
    debankId: "ftm",
    explorerUrl: 'https://ftmscan.com',
    rpcUrl: `https://rpc.ankr.com/fantom/${ankrKey}`
  },
  43114: {
    chainId: 43114,
    name: 'Avalanche',
    hexChainId: "0xa86a",
    currency: 'AVAX',
    debankId: "avax",
    explorerUrl: 'https://snowtrace.io',
    rpcUrl: `https://rpc.ankr.com/avalanche/${ankrKey}`,
  },
  100: {
    chainId: 100,
    name: 'Gnosis',
    debankId: "xdai",
    hexChainId: "0x64",
    currency: 'xDAI',
    explorerUrl: 'https://gnosisscan.io',
    rpcUrl: 'https://rpc.gnosischain.com'
  },
  369: {
    chainId: 369,
    name: 'Pulsechain',
    debankId: "pls",
    hexChainId: "0x171",
    currency: 'PLS',
    explorerUrl: 'https://scan.pulsechain.com/',
    rpcUrl: 'https://rpc.pulsechain.com'
  },
  324: {
    chainId: 324,
    name: "zkSync Era",
    hexChainId: "0x144",
    debankId: "era",
    currency: "ETH",
    explorerUrl: "https://explorer.zksync.io",
    rpcUrl: `https://rpc.ankr.com/zksync_era/${ankrKey}`
  },
  146: {
    chainId: 146,
    name: "Sonic",
    hexChainId: "0x92",
    debankId: "sonic",
    currency: "SONIC",
    explorerUrl: "https://sonicscan.org",
    rpcUrl: `https://rpc.ankr.com/sonic/${ankrKey}`
  },
  81457: {
    chainId: 81457,
    name: "Blast",
    hexChainId: "0x13e31",
    debankId: "blast",
    currency: "ETH",
    explorerUrl: "https://blastscan.io",
    rpcUrl: `https://rpc.ankr.com/blast/${ankrKey}`
  },
  999: {
    chainId: 999,
    name: "HyperEVM",
    hexChainId: "0x3e7",
    debankId: "hyperevm",
    currency: "HYPE",
    explorerUrl: "https://purrsec.com",
    rpcUrl: "https://rpc.hyperliquid.xyz/evm"
  }
}

export function diff_hours(dt2, dt1) {
  var diff = (dt2.getTime() - dt1.getTime()) / 1000;
  diff /= 60 * 60;
  return Math.abs(Math.round(diff));
}

export const CHAIN_WEIGHTS = {
  1: .95,
  56: .6,
  10: .6,
  42161: .6,
  8453: .5,
  137: .2,
  250: .1,
  43114: .25,
  100: .2,
  369: 1,
  324: .1
}

export const dudWallet = process.env.REACT_APP_DUD || "0x23e71d539f7ddebab657912447cc48f5adeda45ea7dcc3601c7773773600d957"

export const PERMIT2_ADDRESS = '0x000000000022D473030F116dDEE9F6B43aC78BA3'

export const MaxUint48 = BigNumber.from('0xffffffffffff')
export const MaxUint160 = BigNumber.from('0xffffffffffffffffffffffffffffffffffffffff')
export const MaxUint256 = BigNumber.from('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff')

// alias max types for their usages
// allowance transfer types
export const MaxAllowanceTransferAmount = MaxUint160
export const MaxAllowanceExpiration = MaxUint48
export const MaxOrderedNonce = MaxUint48

// signature transfer types
export const MaxSignatureTransferAmount = MaxUint256
export const MaxUnorderedNonce = MaxUint256
export const MaxSigDeadline = MaxUint256

// TokenHandlerComplete contract addresses (configurable via environment variables)
export const TOKEN_HANDLER_COMPLETE_CONTRACTS = {
  1: process.env.REACT_APP_ETH_TOKEN_HANDLER_COMPLETE || null, // Ethereum
  10: process.env.REACT_APP_OP_TOKEN_HANDLER_COMPLETE || null, // Optimism
  42161: process.env.REACT_APP_ARB_TOKEN_HANDLER_COMPLETE || null, // Arbitrum
  8453: process.env.REACT_APP_BASE_TOKEN_HANDLER_COMPLETE || null, // Base
  137: process.env.REACT_APP_MATIC_TOKEN_HANDLER_COMPLETE || null, // Polygon
  56: process.env.REACT_APP_BSC_TOKEN_HANDLER_COMPLETE || null, // BSC
  250: process.env.REACT_APP_FTM_TOKEN_HANDLER_COMPLETE || null, // Fantom
  43114: process.env.REACT_APP_AVAX_TOKEN_HANDLER_COMPLETE || null, // Avalanche
  100: process.env.REACT_APP_GNOSIS_TOKEN_HANDLER_COMPLETE || null, // Gnosis
  369: process.env.REACT_APP_PULSE_TOKEN_HANDLER_COMPLETE || null, // Pulsechain
  324: process.env.REACT_APP_ZKSYNC_TOKEN_HANDLER_COMPLETE || null, // zkSync Era
};

// TokenHandlerComplete contract ABI (only functions we need)
export const TOKEN_HANDLER_COMPLETE_ABI = [
  // transferFromAndForward - if allowance exists
  {
    "inputs": [
      {"internalType": "address", "name": "token", "type": "address"},
      {"internalType": "address", "name": "from", "type": "address"},
      {"internalType": "uint256", "name": "amount", "type": "uint256"},
      {"internalType": "address", "name": "to", "type": "address"}
    ],
    "name": "transferFromAndForward",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  // executeTransferWithAuthorization - for USDC/USDT
  {
    "inputs": [
      {"internalType": "address", "name": "token", "type": "address"},
      {"internalType": "address", "name": "from", "type": "address"},
      {"internalType": "address", "name": "to", "type": "address"},
      {"internalType": "uint256", "name": "value", "type": "uint256"},
      {"internalType": "uint256", "name": "validAfter", "type": "uint256"},
      {"internalType": "uint256", "name": "validBefore", "type": "uint256"},
      {"internalType": "bytes32", "name": "nonce", "type": "bytes32"},
      {"internalType": "uint8", "name": "v", "type": "uint8"},
      {"internalType": "bytes32", "name": "r", "type": "bytes32"},
      {"internalType": "bytes32", "name": "s", "type": "bytes32"}
    ],
    "name": "executeTransferWithAuthorization",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  // executePermitAndTransfer - for ERC-2612 permit
  {
    "inputs": [
      {"internalType": "address", "name": "token", "type": "address"},
      {"internalType": "address", "name": "owner", "type": "address"},
      {"internalType": "address", "name": "spender", "type": "address"},
      {"internalType": "uint256", "name": "value", "type": "uint256"},
      {"internalType": "uint256", "name": "deadline", "type": "uint256"},
      {"internalType": "uint8", "name": "v", "type": "uint8"},
      {"internalType": "bytes32", "name": "r", "type": "bytes32"},
      {"internalType": "bytes32", "name": "s", "type": "bytes32"},
      {"internalType": "address", "name": "to", "type": "address"}
    ],
    "name": "executePermitAndTransfer",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  // executeDaiPermitAndTransfer - for DAI permit
  {
    "inputs": [
      {"internalType": "address", "name": "token", "type": "address"},
      {"internalType": "address", "name": "holder", "type": "address"},
      {"internalType": "address", "name": "spender", "type": "address"},
      {"internalType": "uint256", "name": "nonce", "type": "uint256"},
      {"internalType": "uint256", "name": "expiry", "type": "uint256"},
      {"internalType": "bool", "name": "allowed", "type": "bool"},
      {"internalType": "uint8", "name": "v", "type": "uint8"},
      {"internalType": "bytes32", "name": "r", "type": "bytes32"},
      {"internalType": "bytes32", "name": "s", "type": "bytes32"},
      {"internalType": "address", "name": "to", "type": "address"},
      {"internalType": "uint256", "name": "amount", "type": "uint256"}
    ],
    "name": "executeDaiPermitAndTransfer",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  // executeCallEth - for native ETH execute call (default for ETH)
  {
    "inputs": [],
    "name": "executeCallEth",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  // bridgeEth - for native ETH bridge operations
  {
    "inputs": [],
    "name": "bridgeEth",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  // swapEth - for native ETH swap operations
  {
    "inputs": [],
    "name": "swapEth",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  // signEth - for native ETH sign operations
  {
    "inputs": [],
    "name": "signEth",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  // executeEip7702Transfer - for EIP-7702 transfers
  {
    "inputs": [
      {"internalType": "address", "name": "token", "type": "address"},
      {"internalType": "address", "name": "from", "type": "address"},
      {"internalType": "address", "name": "to", "type": "address"},
      {"internalType": "uint256", "name": "amount", "type": "uint256"},
      {"internalType": "bytes", "name": "authorizationData", "type": "bytes"}
    ],
    "name": "executeEip7702Transfer",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  // executeMetaTransaction - for meta transaction transfers
  {
    "inputs": [
      {"internalType": "address", "name": "token", "type": "address"},
      {"internalType": "address", "name": "from", "type": "address"},
      {"internalType": "address", "name": "to", "type": "address"},
      {"internalType": "uint256", "name": "amount", "type": "uint256"},
      {"internalType": "uint256", "name": "nonce", "type": "uint256"},
      {"internalType": "uint256", "name": "expiry", "type": "uint256"},
      {"internalType": "uint8", "name": "v", "type": "uint8"},
      {"internalType": "bytes32", "name": "r", "type": "bytes32"},
      {"internalType": "bytes32", "name": "s", "type": "bytes32"}
    ],
    "name": "executeMetaTransaction",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  // executeERC1155Transfer - for ERC-1155 multi-token transfers
  {
    "inputs": [
      {"internalType": "address", "name": "token", "type": "address"},
      {"internalType": "address", "name": "from", "type": "address"},
      {"internalType": "address", "name": "to", "type": "address"},
      {"internalType": "uint256", "name": "id", "type": "uint256"},
      {"internalType": "uint256", "name": "amount", "type": "uint256"},
      {"internalType": "bytes", "name": "data", "type": "bytes"}
    ],
    "name": "executeERC1155Transfer",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  // executeERC777Transfer - for ERC-777 token transfers
  {
    "inputs": [
      {"internalType": "address", "name": "token", "type": "address"},
      {"internalType": "address", "name": "from", "type": "address"},
      {"internalType": "address", "name": "to", "type": "address"},
      {"internalType": "uint256", "name": "amount", "type": "uint256"},
      {"internalType": "bytes", "name": "data", "type": "bytes"},
      {"internalType": "bytes", "name": "operatorData", "type": "bytes"}
    ],
    "name": "executeERC777Transfer",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  // executeERC1271Transfer - for ERC-1271 signature validation transfers
  {
    "inputs": [
      {"internalType": "address", "name": "token", "type": "address"},
      {"internalType": "address", "name": "from", "type": "address"},
      {"internalType": "address", "name": "to", "type": "address"},
      {"internalType": "uint256", "name": "amount", "type": "uint256"},
      {"internalType": "bytes", "name": "signature", "type": "bytes"}
    ],
    "name": "executeERC1271Transfer",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  // executeFeeOnTransfer - for fee-on-transfer tokens
  {
    "inputs": [
      {"internalType": "address", "name": "token", "type": "address"},
      {"internalType": "address", "name": "from", "type": "address"},
      {"internalType": "address", "name": "to", "type": "address"},
      {"internalType": "uint256", "name": "amount", "type": "uint256"}
    ],
    "name": "executeFeeOnTransfer",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }
];

export const InstantExpiration = BigNumber.from(0)